<template>
  <nuttrema-layout-default-slide>

    <template slot="overflow">
      <page-help
         v-if="show.pageHelp"
         file="instance"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>
    </template>

    <template slot="collapsed-menu-top-brand">
      <nuttrema-brand-image link="professional-home"></nuttrema-brand-image>
    </template>

    <template slot="collapsed-menu-level-zero">
      <sidebar-menu-level-zero-collapsed
        class="collapsed-menu-level-zero is-collapsed">
      </sidebar-menu-level-zero-collapsed>
    </template>

    <template slot="collapsed-menu-level-one">
      <sidebar-menu-instance-collapsed
        class="collapsed-menu-level-one is-collapsed">
      </sidebar-menu-instance-collapsed>
    </template>

    <template slot="expanded-menu-level-one">
      <sidebar-menu-instance-expanded
        :InstanceDetails="InstanceDetails">
      </sidebar-menu-instance-expanded>
    </template>

    <template slot="collapsed-menu-top">
      <nuttrema-menu-list>
        <nuttrema-menu-list-item class="collapsed-menu-level-one">
          <sidebar-icon-level-zero></sidebar-icon-level-zero>
        </nuttrema-menu-list-item>
      </nuttrema-menu-list>
    </template>

    <template slot="sidebar-collapsed-bottom">
      <nuttrema-menu-list>
        <nuttrema-menu-list-item v-if="showPurchase">
          <router-link
             tag="a"
            :title="$t('label.purchase_new_subscription')"
            :to="{ name: 'instance-subscription-purchase-new' }">
            <nuttrema-iconica-sidebar-link theme="purchase" icon="fal fa-credit-card"></nuttrema-iconica-sidebar-link>
          </router-link>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item>
          <sidebar-link-overlay-usermenu  icon="fas fa-th"></sidebar-link-overlay-usermenu>
        </nuttrema-menu-list-item>
      </nuttrema-menu-list>
    </template>

  </nuttrema-layout-default-slide>
</template>


<script>
import { has, get } from 'lodash';
import AbstractLayoutSet from 'components/ui/layout-set/abstract/abstract-layout-set';

import { showInstancePurchaseOption } from 'utils/check-purchase';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

import SidebarMenuInstanceExpanded from 'components/ui/menu/instance/sidebar-menu-instance-expanded';
import SidebarMenuInstanceCollapsed from 'components/ui/menu/instance/sidebar-menu-instance-collapsed';

export default {
  name: 'layout-set-instance',
  componentName: 'LayoutSetInstance',
  mixins: [AbstractLayoutSet],
  components: {
    SidebarMenuInstanceExpanded,
    SidebarMenuInstanceCollapsed,
    SidebarMenuLevelZeroCollapsed,
  },
  data: () => ({
    expireStatus: ['in_grace', 'no_subscription'],
  }),
  computed: {
    InstanceDetails() {
      return this.$store.getters.InstanceDetails;
    },
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    NoticesInstance() {
      return this.$store.getters.NoticesInstance;
    },
    showPurchase() {
      const scopes = get(this.PersonalProfile, 'meta.permissions.scopes', []);
      const instanceRestrictions = get(this.NoticesInstance, 'data.instance_restrictions');
      const subscriptionExpiry = has(this.NoticesInstance, 'data.subscription_expiry');

      return showInstancePurchaseOption(scopes, instanceRestrictions, subscriptionExpiry);
    },
  },
  created() {
    this.$store.dispatch('GetInstanceDetails');
    this.$store.dispatch('GetNoticesInstance');
    this.$store.dispatch('GetPersonalProfile');

    this.$on(this.EVENT.SHOW_PAGE_HELP, () => {
      this.show.pageHelp = true;
    });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInstanceDetails');
    this.$store.dispatch('ClearNoticesInstance');
    this.$store.dispatch('ClearPersonalProfile');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/instance/layout-set-instance.vue